module.exports = __webpack_public_path__ + "static/media/star-christmas.18250c3a.svg";